import React, { useContext } from 'react';
import {
    GelBoxLayout,
    GelScreenDetectorContext,
    GelContainerLite,
    GelHeading3,
    GelParagraph,
    GelRowLayout,
    GelSpinner
} from '@tal-gel/components';
import { getGelTokens } from '@tal-gel/theming';
import FundBanner from '../../../components/fundBanner';
import { useGetHomePageContent } from '../../../common/api/graphQLDataFetch';

const InvalidCorroLink: React.FC = () => {
    const {
        global: { sizeBaseUnit, sizeNone, themeColorTextDanger },
    } = getGelTokens();

    const { screen, isLargerThanSmScreen } = useContext(
        GelScreenDetectorContext
    ) as GelScreenDetectorContext;

    const { data, isLoading } = useGetHomePageContent()

    if (isLoading) return <GelSpinner medium overlay />;

    return (
        <GelContainerLite
            style={{
                paddingRight: sizeNone,
                paddingLeft: sizeNone,
                paddingBottom: sizeBaseUnit * 15,
                paddingTop: sizeBaseUnit * 15,
                overflow: "hidden",
            }}
        >
            <GelBoxLayout alignment="start" space={[1, 4]} gutter="none">
                <GelRowLayout gutter="medium" style={{ paddingLeft: sizeBaseUnit * 3 }}>
                    <div style={{ paddingRight: sizeBaseUnit * 16, paddingLeft: sizeBaseUnit * 16 }}>
                        <GelHeading3 style={{ color: themeColorTextDanger, paddingBottom: '16px' }}>
                            {data?.corroLink?.InvalidLink?.Heading}
                        </GelHeading3>
                        <GelParagraph style={{ color: themeColorTextDanger }}>
                            {data?.corroLink?.InvalidLink?.SubHeading}
                        </GelParagraph>
                    </div>
                </GelRowLayout>

                {isLargerThanSmScreen(screen) && <FundBanner />}
            </GelBoxLayout>
        </GelContainerLite>);
}

export default InvalidCorroLink;